import BaseModal from "../../../../../components/layout/BaseModal"

type SolveEscalationModalType = {
    modalId: number
    solveEscalation: () => void
}

export default function SolveEscaltionModal(props: SolveEscalationModalType) {
    return (
        <BaseModal
            title={"Eskalation wurde manuell bearbeitet"}
            size
            modalId={props.modalId}
            bottomRow={
                <div className="flex justify-end w-full">
                    <button onClick={props.solveEscalation} className="btn btn-primary">
                        Bestätigen
                    </button>
                </div>
            }>
            <p className="py-4">Diese als eskaliert markierte Zahlungsanforderung wurde bereits manuell bearbeitet. Durch die Bestätigung wird nur die Eskalationsmarkierung aufgehoben - es erfolgen keine weiteren systemseitigen Änderungen.</p>
        </BaseModal>
    )
}
